import { twMerge } from "tailwind-merge"
import { slidesById } from "../../../constants/content"
import NewIllustration from "../../products/datashare/NewIllustration"

function T1Chip() {
  return (
    <div
      className={twMerge(
        "rounded-[25px]",
        "shadow-[0_0_20px_10px_theme(colors.neutral[900]/0.15)] md:shadow-[0_0_40px_10px_theme(colors.neutral[900]/0.15)] lg:shadow-[0_0_150px_20px_theme(colors.neutral[900]/0.15)]",
        "dark:shadow-[0_0_20px_10px_#0d0d0d] dark:md:shadow-[0_0_40px_10px_#0d0d0d] dark:lg:shadow-[0_0_150px_20px_#0d0d0d]",
      )}
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden",
        backgroundColor: slidesById.trust.accentColor,
      }}
    >
      <NewIllustration />
    </div>
  )
}

export default T1Chip
